import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'General settings',
  attributeName: 'mainhubGeneralSettings',
  fields: [
    {
      attributeName: 'name',
      label: 'App Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of the application',
      canEdit: true,
    },
    {
      attributeName: 'internalName',
      label: 'Internal Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Internal system name',
      canEdit: true,
    },
  ]
}